import axios from 'axios';
import * as devConfig from "../../../config/myConfig";
import { MSG_MODES, MSG_TYPES, setMessage } from "../../libs/message";
import { Message, MessageBox } from 'element-ui'
import UserPersistence from "../../persistence/UserPersistence";
import AppPersistence from "../../persistence/AppPersistence";
import ArrayUtils from "../../libs/utils/ArrayUtils";
import { router } from "../../router";
import {
  BASER_SERVER_ERROR_CODE_WITH_ERROR_MESSAGE, COMMON_SERVER_ERROR_CODES,
  COMMON_SERVER_ERROR_MESSAGE, DURATION_OF_SERVER_ERROR_MESSAGE, EXIT_URL, ENV,
  WHITE_LIST_CODE
} from "../../config/app";
import CustomLoading from "./helper"

//控制台打印样式
const CONSOLE_COLOR = 'background: #4368aa;color: #FFFFFF';
const CONSOLE_COLOR_ERROR = 'background: #e83838;color: #FFFFFF';

//控制台是否打印信息标识
const ENABLE_DEBUG = devConfig.ENABLE_API_LOG === undefined ?
  ENV.NODE_ENV !== 'production' : devConfig.ENABLE_API_LOG;

let flag = true;// token过期时，错误确认框显示标识


// 创建加载页对象
const customLoadingObj = new CustomLoading();

// 创建axios实例
let service = axios.create({
  baseURL: ENV.BASE_API,
});

// 请求发送前配置
service.interceptors.request.use((config) => {
  customLoadingObj.showFullScreenLoading();
  config.headers.token = UserPersistence.getToken();
  // 根据请求地址前缀判断 header 中的参数配置 x-orgId-header（报账中心） x-abId-header（基础数据）
  config.headers.authorization = UserPersistence.getToken() ? `bearer ${UserPersistence.getToken()}` : 'Basic d2ViQXBwOndlYkFwcA==';
  //abid  为零因为全局数据维护费用类型查询科目的时候需要
  config.headers['x-abId-header'] = UserPersistence.getOrgId() && UserPersistence.getOrgId() != 'null' ? `${UserPersistence.getOrgId()}` : "0";

  config.headers['x-orgId-header'] = UserPersistence.getOrganizationId() && UserPersistence.getOrganizationId() != 'null' ? `${UserPersistence.getOrganizationId()}` : "1234";
  config.headers.companyId = UserPersistence.getOrgId() ? `${UserPersistence.getOrgId()}` : "0";
  config.headers.userId = UserPersistence.getBaseInfo().user ? UserPersistence.getBaseInfo().user.userId || UserPersistence.getBaseInfo().user.id : '0'
  return config;
})

// 请求响应处理
service.interceptors.response.use((response) => {
  customLoadingObj.tryHideFullScreenLoading();



  printResponse(response);// 打印请求url
  if (response.config.method === 'option') return; //检测请求直接返回

  let res = response.data;
  // 服务器返回错误信息处理
  if (res.error || res.code) {
    handleResponseError(res.error || res);
  }
  const { data, status } = response;
  // 获取文件名
  let fileName = response.config.fileName || response.headers['content-disposition'];
  // 判断是否下载文件
  if (fileName) {
    fileName = decodeURIComponent(fileName);
    const preStr = "attachment;filename=UTF-8''";
    const preStrTwo = "attachment;filename=";
    if (fileName.startsWith(preStr)) {
      fileName = fileName.substr(preStr.length);
    } else if (fileName.startsWith(preStrTwo)) {
      const split = fileName.split("=");
      fileName = split[1];
    }
    let contentType = response.headers['content-type'];
    if (contentType && contentType.indexOf(";") !== -1) {
      contentType = contentType.substr(0, contentType.indexOf(";"));
    }
    let blob = new Blob([response.data], { type: contentType });
    let reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = function (e) {
      // 下载文件
      if ('download' in document.createElement('a')) {
        // 非IE下载
        const a = document.createElement('a');
        const downloadUrl = window.URL.createObjectURL(blob);
        a.href = downloadUrl;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
      } else {
        // IE下载
        navigator.msSaveBlob(blob, fileName);
      }
      return Promise.resolve("下载文件成功");
    }
  }
  return res
}, (error) => {
  customLoadingObj.tryHideFullScreenLoading();
  handleNetworkError(error);
})

function printResponse(response) {
  if (ENABLE_DEBUG) {
    let hasError = response.data.error;
    if (hasError) {
      console.log("%c Http ", CONSOLE_COLOR_ERROR, "<- URL: " + response.config.url + "\n       <- error:", response.data.error);
    } else {
      console.log("%c Http ", CONSOLE_COLOR, "<- URL: " + response.config.url + "\n       <- data:", response.data);
    }
  }
}
function handleResponseError(error) {
  let errorCode = error.code,
    errorMessage = null;

  if (errorCode && ArrayUtils.oneOf(errorCode, COMMON_SERVER_ERROR_CODES)) {
    errorMessage = COMMON_SERVER_ERROR_MESSAGE;
  } else if (parseInt(errorCode) === 40001 || parseInt(errorCode) === 40002) {//token过期，清空缓存数据，重新登录
    if (!flag) return;
    flag = false;
    setTimeout(() => {flag = true},5000);
    MessageBox.confirm(
      error.message, '提示', {
        showCancelButton: false,
        showClose: false,
        confirmButtonText: '确定',
        type: 'warning',
        callback: (action) => {
          let EXITURL = EXIT_URL();
          AppPersistence.clear();
          UserPersistence.clear();
          if (ENV.NODE_ENV !== 'development') {
            if(window != top){
              parent.postMessage({
                isExit: true,
              }, '*');
            } else {
              window.location.href = EXITURL;
            }
          } else {//localhost
            router.push({name: 'index', params: {servers: UserPersistence.getServiceType()}});
          }
        }
      }
    );
    return;
  } else if (errorCode > BASER_SERVER_ERROR_CODE_WITH_ERROR_MESSAGE || errorCode>DURATION_OF_SERVER_ERROR_MESSAGE) {
    errorMessage = error.message;
  }else if(errorCode === 1){
    errorMessage = error.msg;
  }

  if (errorCode && ArrayUtils.oneOf(errorCode, WHITE_LIST_CODE)) return;

  if(!errorMessage) return;

  setMessage({
    type: MSG_TYPES.ERROR,
    mode: MSG_MODES.MESSAGE,
    duration: DURATION_OF_SERVER_ERROR_MESSAGE,
    message: errorMessage
  });
}
function handleNetworkError(error) {
  if (error.response) {
    let errorRes = error.response.data;
    if (errorRes.msg.indexOf('Invalid access token') > -1) {// token过期或被踢情况
      if (flag) {
        flag = false;
        setTimeout(() => {
          flag = true
        }, 5000);
        MessageBox.confirm(
          '登陆过期，请重新登录！', '提示', {
          showCancelButton: false,
          showClose: false,
          confirmButtonText: '确定',
          type: 'warning',
          callback: (action) => {
            let EXITURL = EXIT_URL();
            AppPersistence.clear();
            UserPersistence.clear();
            if (ENV.NODE_ENV !== 'development') {
              if (window != top) {
                parent.postMessage({
                  isExit: true,
                }, '*');
              } else {
                // 按需非开发环境推出地址跳转
                sessionStorage.clear();
                localStorage.clear();
                router.push({ name: 'login' });
                // window.location.href = EXITURL;
              }
            } else {//localhost
              sessionStorage.clear();
              localStorage.clear();
              router.push({ name: 'login' });
            }
          }
        }
        );
      }
      return;
    } else if (errorRes.msg.indexOf('Access Denied') > -1) {// 没有权限
      setMessage({
        type: MSG_TYPES.ERROR,
        mode: MSG_MODES.MESSAGE,
        duration: DURATION_OF_SERVER_ERROR_MESSAGE,
        message: '没有权限，请联系管理员分配权限！'
      });
      return;
    }
    switch (error.response.status) {
      case 400: Message.error('请求错误(400)'); break;
      case 401:
        Message.error('未授权，请重新登录(401)');
        sessionStorage.clear();
        localStorage.clear();
        router.push({
          path: '/login'
        });
        break;
      case 403: Message.error('拒绝访问(403)'); break;
      case 404: Message.error(`请求出错(404)`); break;
      case 408: Message.error('请求超时(408)'); break;
      case 500: Message.error('服务器错误(500)'); break;
      case 501: Message.error('服务未实现(501)'); break;
      case 502: Message.error('网络错误(502)'); break;
      case 503: Message.error('服务不可用(503)'); break;
      case 504: Message.error('网络超时(504)'); break;
      case 505: Message.error('HTTP版本不受支持(505)'); break;
      default: Message.error(`连接出错(${error.response.status})!`);
    }
  }
  return Promise.reject(error.response.data) //请求错误时，直接结束
}

export default service;



// WEBPACK FOOTER //
// ./src/api/Http/request.js